import React from 'react'

import DocumentIcon from "../../../../core/gd-components/icons/document/note-icon-ui5"
import DocumentMoreButton from "../../../../core/gd-ui/more/document/more-button"
import Document from "../../../../core/model2/doc/document"

type Props = {
    style?          : any

    document        : {
        id              : ID
        documentTypeId  : ID
        name            : string
    }

    dndPreview?     : boolean
    dndIsDragged?   : boolean
}


// const debug = "NavigationMenuItemDocument"
const debug = false

export default class NavigationMenuItemDocument extends React.Component<Props, any> {

    constructor(props:Props) {
        super(props)

        this.state = {
            showPopover: false
        }

        debug && console.log(debug, 'constructor', this.props)
    }

    componentDidMount() {
        gd.modelBus.subscribe('document', this, this.onDocumentChange)
    }

    componentWillUnmount() {
        gd.modelBus.unsubscribe(this)
    }

    async onDocumentChange(method: string, data: any, header: any) {
        debug && console.log(debug, 'onDocumentChange', data, this.props.document)

        if (this.props.document?.id === header.document.id) {
            if (data.name)          this.props.document.name            = data.name
            if (data.noteTypeId)    this.props.document.documentTypeId  = data.noteTypeId
            this.forceUpdate()
        }
    }

    onTogglePopover = (value: boolean) => {
        this.setState({
            showPopover: value
        })
    }

    onClick = () => {
        gd.goTo('n/'+this.props.document.id)
    }

    render() {
        const classes = Classes('item', 'documentId-'+this.props.document.id /*required for scroll to node*/, {
            'dnd-preview'   : this.props.dndPreview,
            'dnd-is-dragged': this.props.dndIsDragged,
            'show-popover'  : this.state.showPopover
        });

        // just for better typing
        const document : Document = new Document(this.props.document)

        // style is required for ReorderList (pointer-events: none)
        return (
            <div className={classes} style={this.props.style} onClick={this.onClick}>
                <div className="row">
                    <DocumentIcon noteTypeId={this.props.document.documentTypeId} className="icon" />
                    <div className="name">{this.props.document.name}</div>
                    <DocumentMoreButton type            = "menu"
                                        model           = {document}
                                        onTogglePopover = {this.onTogglePopover}/>
                </div>
            </div>
        )
    }
}